import React, { useState, useEffect, useRef } from 'react';
import builder from '../../Assets/Last.webp';
import { GiPlainSquare } from 'react-icons/gi';

const Progress = () => {
  const [progress, setProgress] = useState({ building: 0, remodeling: 0 });
  const progressRef = useRef(null);

  useEffect(() => {
    const progressElement = progressRef.current; // Store ref value in a variable
  
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setProgress({ building: 90, remodeling: 85 });
        }
      },
      { threshold: 0.5 } // Trigger animation when 50% of the section is visible
    );
  
    if (progressElement) {
      observer.observe(progressElement);
    }
  
    return () => {
      if (progressElement) {
        observer.unobserve(progressElement);
      }
    };
  }, []);
  

  return (
    <div ref={progressRef} className="flex flex-col bg-gray-100 lg:flex-row max-w-screen-2xl mx-auto items-center">
      
      {/* Left Section */}
      <div className="w-full lg:w-1/2 flex flex-col space-y-6 p-6 md:p-8">
        
        {/* Title Section */}
        <div className="flex items-center space-x-2">
          <GiPlainSquare className="text-[#068b07]" size={20} />
          <p className="text-gray-500 font-medium text-md">
            Construction Experience
          </p>
        </div>

        {/* Heading & Description */}
        <h1 className="font-semibold text-2xl md:text-4xl leading-snug">
          Trusted Company <br /> to Build your Dream Home
        </h1>
        <p className="text-gray-600 text-sm md:text-base font-medium">
          We are proud to have built a reputation as a leader in the construction of high-quality
          facilities. Clients, industry professionals, and financial institutions view us as a premier
          choice for design and general construction services.
        </p>

        {/* Progress Bars */}
        <div className="mt-4 space-y-4">
          
          {/* Building Construction */}
          <div>
            <p className="text-gray-600 text-sm md:text-md font-medium flex justify-between">
              Building Construction <span>{progress.building}%</span>
            </p>
            <div className="w-full bg-gray-300 h-2 rounded-full mt-1">
              <div
                className="bg-[#068b07] h-2 rounded-full transition-all duration-1000"
                style={{ width: `${progress.building}%` }}
              ></div>
            </div>
          </div>

          {/* Home Remodeling */}
          <div>
            <p className="text-gray-600 text-sm md:text-md font-medium flex justify-between">
              Home Remodeling <span>{progress.remodeling}%</span>
            </p>
            <div className="w-full bg-gray-300 h-2 rounded-full mt-1">
              <div
                className="bg-[#068b07] h-2 rounded-full transition-all duration-1000"
                style={{ width: `${progress.remodeling}%` }}
              ></div>
            </div>
          </div>

        </div>

      </div>

      {/* Right Image Section */}
      <div className="w-full lg:w-1/2 flex justify-center lg:justify-end">
        <img 
          src={builder} 
          alt="Builder" 
          className="w-full h-auto object-cover max-h-[450px] md:max-h-[500px]"
        />
        
      </div>

    </div>
  );
}

export default Progress;
